<template>
  <p :class="classes">
    <slot />
  </p>
</template>

<script>
import { parseInt } from 'lodash-es'

export default {
  name: 'BaseSubline',
  props: {
    layout: {
      type: [String, Number],
      default: '',
    },
    alignment: {
      type: String,
      default: 'left',
    },
  },
  computed: {
    classes() {
      return [
        'subline',
        parseInt(this.layout) ? `h${this.layout}` : this.layout,
        this.$attrs.class,
        `text-${this.alignment}`,
      ]
    },
  },
}
</script>
